import { gettext } from '@core/lib/utils/localization';

export default [
  {
    name: gettext('role.admin'),
    key: 'admin',
    description: gettext('role.admin.description'),
  },
  {
    name: gettext('role.editor'),
    key: 'editor',
    description: gettext('role.editor.description'),
  },
  {
    name: gettext('role.reader'),
    key: 'reader',
    description: gettext('role.reader.description'),
  },
  {
    name: gettext('role.custom'),
    key: 'custom',
    description: gettext('role.custom.description'),
  },
];
